<template>
    <div>
      <div class="title-header">
        <div class="title-header-font">产品设备</div>
      </div>
      <!--面包屑-->
      <CurrentLocal :titles="titles"></CurrentLocal>
      <!--主要内容-->
      <div style="width: 1200px; margin: 0 auto; min-height: 500px">
        <el-row :gutter="50">
          <product-items v-for="productItem in productItems" :key="productItem.product_id" :productItem="productItem"></product-items>
        </el-row>
      </div>
    </div>
</template>

<script>
import CurrentLocal from '@/components/CurrentLocal/CurrentLocal'
import ProductItems from '@/views/product/ProductItems'
import { product } from '@/api/product'
export default {
  name: 'product',
  components: { ProductItems, CurrentLocal },
  data () {
    return {
      productItems: [],
      titles: [{ path: '/', name: '首页' },
        { path: '/product', name: '产品设备' }]
    }
  },
  created () {
    this.getProductItems()
  },
  methods: {
    getProductItems () {
      product().then(res => {
        this.productItems = res.body
      })
    }
  }
}
</script>

<style scoped>

</style>
